module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["资源详情"]), " ", (_vm.infoStatus.myCountS == 1) ? _vm._h('span', {
    staticClass: "icon-right pull-right img-fav active",
    on: {
      "click": function($event) {
        _vm.callcollectionZx()
      }
    }
  }, ["取消收藏"]) : _vm._h('span', {
    staticClass: "icon-right pull-right img-fav",
    on: {
      "click": function($event) {
        _vm.collectionZx()
      }
    }
  }, ["收藏"]), " "]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "main-page bg-white",
    staticStyle: {
      "min-height": "600px"
    }
  }, [_vm._h('div', {
    staticClass: "padding-15",
    attrs: {
      "id": "myIframe"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-f3df349c!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/information/InformationDetail.vue
// module id = 226
// module chunks = 1